/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

export const ENDPOINT_GROUPS = {
	users: {
		name: "users",
		operations: {
			getRoles: {
				name: "roles",
				endpoint: "dashboard/roles",
				service: "users/roles"
			},
			getUserInfo: {
				name: "user-info",
				endpoint: "dashboard/users/userinfo",
				service: "users/user-info"
			},
			getUsers: {
				name: "get-users",
				endpoint: "dashboard/users",
				service: "users/get-users"
			},
			getUser: {
				name: "get-user",
				endpoint: "dashboard/users/tenant/:tenantId/:userId",
				service: "users/get-user"
			},
			addUser: {
				name: "add-user",
				endpoint: "dashboard/users/tenant/:tenantId",
				service: "users/add-user"
			},
			updateUser: {
				name: "update-user",
				endpoint: "dashboard/users/tenant/:tenantId/:userId",
				service: "users/update-user"
			},
			deleteUser: {
				name: "delete-user",
				endpoint: "dashboard/users/tenant/:tenantId/:userId",
				service: "users/delete-user"
			},
			logout: {
				name: "logout",
				endpoint: "logout",
				service: "users/logout"
			},
			getUsersFunctionalUnits: {
				name: "get-users-functional-units",
				endpoint: "dashboard/users/filters/functional-units",
				service: "users/get-users-functional-units"
			}
		}
	},
	anomalyDetection: {
		name: "anomaly-detection",
		operations: {
			getAllAnomalousApplications: {
				name: "get-all-anomalous-applications",
				endpoint: "dashboard/anomalyDetection/:tenantId",
				service: "anomaly-detection/get-all-anomalous-applications"
			},
			getAnomaliesByApplication: {
				name: "get-anomalies-by-application",
				endpoint: "dashboard/anomalyDetection/:applicationId/details",
				service: "anomaly-detection/get-anomalies-by-application"
			},
			addUserDeviceByTenant: {
				name: "add-user-device-by-tenant",
				endpoint: "dashboard/anomalyDetection/pub-sub/:tenantId",
				service: "anomaly-detection/add-user-device-by-tenant"
			},
			updateUserNotificationSettings: {
				name: "update-user-notification-settings",
				endpoint: "dashboard/anomalyDetection/update-setting/:tenantId",
				service: "anomaly-detection/update-user-notification-settings"
			}
		}
	},
	dashboardCio: {
		name: "dashboard-cio",
		operations: {
			getSummary: {
				name: "get-summary",
				endpoint: "impact/general-information",
				service: "dashboard-cio/get-summary"
			},
			getForecast: {
				name: "get-forecast",
				endpoint: "impact/trendline-chart",
				service: "dashboard-cio/get-forecast"
			},
			getEmissionsShare: {
				name: "get-emissions-share",
				endpoint: "impact/pie-chart/total-breakdown",
				service: "dashboard-cio/get-emissions-share"
			},
			getDetails: {
				name: "get-details",
				endpoint: "impact/bar-chart/scope-breakdown",
				service: "dashboard-cio/get-details"
			}
		}
	},
	dashboardServiceNow: {
		name: "dashboard-service-now",
		operations: {
			getGeneralInformation: {
				name: "get-general-information",
				endpoint: "devices/servicenow/general-information",
				service: "dashboard-service-now/get-general-information"
			},
			getDevicesCategories: {
				name: "get-devices-categories",
				endpoint: "devices/servicenow/categories",
				service: "dashboard-service-now/get-devices-categories"
			},
			getDeviceCarbonFootprint: {
				name: "get-device-carbon-footprint",
				endpoint: "devices/servicenow/bar-chart/co2/category",
				service: "dashboard-service-now/get-device-carbon-footprint"
			},
			postScopeCarbonFootprintBar: {
				name: "post-scope-carbon-footprint-bar",
				endpoint: "devices/servicenow/bar-chart/co2/scope",
				service: "dashboard-service-now/post-scope-carbon-footprint-bar"
			},
			getScopeCarbonFootprintTable: {
				name: "get-scope-carbon-footprint-table",
				endpoint: "devices/servicenow/manufacturers/scope",
				service: "dashboard-service-now/get-scope-carbon-footprint-table"
			},
			postManufacturerEmissionPie: {
				name: "post-manufacturer-emission-pie",
				endpoint: "devices/servicenow/pie-chart/co2",
				service: "dashboard-service-now/post-manufacturer-emission-pie"
			},
			getDeviceStatusEmissionPie: {
				name: "get-device-status-emission-pie",
				endpoint: "devices/servicenow/pie-chart/device-status",
				service: "dashboard-service-now/get-device-status-emission-pie"
			},
			getDevicesModelsBar: {
				name: "get-devices-models-bar",
				endpoint: "devices/servicenow/bar-chart/models",
				service: "dashboard-service-now/get-devices-models-bar"
			},
			getDevicesModelsBarPerDevice: {
				name: "get-devices-models-bar-per-device",
				endpoint: "devices/servicenow/bar-chart/models/per-device",
				service: "dashboard-service-now/get-devices-models-bar-per-device"
			},
			getDevicesLocationBar: {
				name: "get-devices-location-bar",
				endpoint: "devices/servicenow/bar-chart/co2/locations",
				service: "dashboard-service-now/get-devices-location-bar"
			},
			getDevicesLocationBarPerDevice: {
				name: "get-devices-location-bar-per-device",
				endpoint: "devices/servicenow/bar-chart/co2/locations/per-device",
				service: "dashboard-service-now/get-devices-location-bar-per-device"
			},
			getTotalDevicesOverTime: {
				name: "get-total-devices-over-time",
				endpoint: "devices/servicenow/line-chart/co2/total-over-time",
				service: "dashboard-service-now/get-total-devices-over-time"
			},
			getLocationDevicesOverTime: {
				name: "get-location-devices-over-time",
				endpoint: "devices/servicenow/line-chart/co2/location-over-time",
				service: "dashboard-service-now/get-location-devices-over-time"
			},
			getLifecycleSavingsDevicesOverTime: {
				name: "get-lifecycle-savings-devices-over-time",
				endpoint: "devices/servicenow/line-chart/co2/lifecycle-saving",
				service: "dashboard-service-now/get-lifecycle-savings-devices-over-time"
			},
			getManufacturerEmissionTable: {
				name: "get-manufacturer-emission-table",
				endpoint: "devices/servicenow/manufacturers-emission",
				service: "dashboard-service-now/get-manufacturer-emission-table"
			}
		}
	},
	dashboardConfig: {
		name: "dashboard-config",
		operations: {
			getConfigurationByTenant: {
				name: "get-configuration-by-tenant",
				endpoint: "dashboard/configuration",
				service: "dashboard-config/get-configuration-by-tenant"
			}
		}
	},
	dashboardEnergy: {
		name: "dashboard-energy",
		operations: {
			getAppsPerformance: {
				name: "get-apps-performance",
				endpoint: "dashboard/line-chart/energy/apps-performance",
				service: "dashboard-energy/get-apps-performance"
			},
			getTotalCo2: {
				name: "get-total-co2",
				endpoint: "dashboard/kpi/energy/total",
				service: "dashboard-energy/get-total-co2"
			},
			getWorst10Apps: {
				name: "get-worst-10-apps",
				endpoint: "dashboard/bar-chart/energy/worst-10-apps",
				service: "dashboard-energy/get-worst-10-apps"
			},
			getWorst10Layers: {
				name: "get-worst-10-layers",
				endpoint: "dashboard/bar-chart/energy/worst-10-layers",
				service: "dashboard-energy/get-worst-10-layers"
			}
		}
	},
	dashboardSci: {
		name: "dashboard-sci",
		operations: {
			getGreenScore: {
				name: "get-green-score",
				endpoint: "dashboard/scatter-chart/green-score",
				service: "dashboard-sci/get-green-score"
			},
			getWorst10Emissions: {
				name: "get-worst-10-emissions",
				endpoint: "dashboard/bar-chart/sci/worst-10",
				service: "dashboard-sci/get-worst-10-emissions"
			}
		}
	},
	dashboardSoftwareAssets: {
		name: "dashboard-software-assets",
		operations: {
			getAppsPerformance: {
				name: "get-apps-performance",
				endpoint: "dashboard/line-chart/co2/apps-performance",
				service: "dashboard-software-assets/get-apps-performance"
			},
			getAppsWaterConsumption: {
				name: "get-apps-water-consumption",
				endpoint: "dashboard/line-chart/water/apps-consumption",
				service: "dashboard-software-assets/get-apps-water-consumption"
			},
			getTotalCo2: {
				name: "get-total-co2",
				endpoint: "dashboard/kpi/co2/total",
				service: "dashboard-software-assets/get-total-co2"
			},
			getTotalEmissions: {
				name: "get-total-emissions",
				endpoint: "dashboard/swassets/total",
				service: "dashboard-software-assets/get-total-emissions"
			},
			exportCsv: {
				name: "export-csv",
				endpoint: "dashboard/export",
				service: "dashboard-software-assets/export-csv"
			},
			exportManifest: {
				name: "export-manifest",
				endpoint: "dashboard/export-manifest",
				service: "dashboard-software-assets/export-manifest"
			},
			exportInsightsReport: {
				name: "export-insights-report",
				endpoint: "usersDashboard/reportAutomation/get-ict-carbon-insights-report/:format",
				service: "dashboard-software-assets/export-insights-report"
			},
			getEnvironmentalImpactByApplication: {
				name: "get-environmental-impact-by-application",
				endpoint: "dashboard/environmental-impact/by-application",
				service: "dashboard-software-assets/get-environmental-impact-by-application"
			},
			getApplicationsIds: {
				name: "get-applications-ids",
				endpoint: "dashboard/users/filters/applications-ids",
				service: "dashboard-software-assets/get-applications-ids"
			},
			getLayerIds: {
				name: "get-layer-ids",
				endpoint: "dashboard/users/filters/layer-ids",
				service: "dashboard-software-assets/get-layer-ids"
			}
		}
	},
	dashboardComponentEmissions: {
		name: "dashboard-component-emissions",
		operations: {
			getTotalCo2Emissions: {
				name: "get-total-co2-emissions",
				endpoint: "dashboard/line-chart/co2/total-emissions",
				service: "dashboard-component-emissions/get-total-co2-emissions"
			},
			getTop10Emissions: {
				name: "get-top-10-emissions",
				endpoint: "dashboard/bar-chart/co2/embodied-by-apps",
				service: "dashboard-component-emissions/get-top-10-emissions"
			},
			getResourcesEmissions: {
				name: "get-resources-emissions",
				endpoint: "dashboard/pie-chart/co2/resources-emissions",
				service: "dashboard-component-emissions/get-resources-emissions"
			}
		}
	},
	dashboardImpact: {
		name: "dashboard-impact",
		operations: {
			getWorst10Layers: {
				name: "get-worst-10-layers",
				endpoint: "dashboard/bar-chart/co2/worst-10-layers",
				service: "dashboard-impact/get-worst-10-layers"
			},
			getWorst10Apps: {
				name: "get-worst-10-apps",
				endpoint: "dashboard/bar-chart/co2/worst-10-apps",
				service: "dashboard-impact/get-worst-10-apps"
			},
			downloadAsCsv: {
				name: "download-as-csv",
				endpoint: "impact/export-csv",
				service: "dashboard-impact/download-as-csv"
			}
		}
	},
	dashboardDataCenter: {
		name: "dashboard-data-center",
		operations: {
			getSiteList: {
				name: "get-site-list",
				endpoint: "dashboard/datacenter/sites",
				service: "dashboard-data-center/get-site-list"
			},
			getMetricOverview: {
				name: "get-metric-overview",
				endpoint: "dashboard/datacenter/metric-overview",
				service: "dashboard-data-center/get-metric-overview"
			},
			getMetricData: {
				name: "get-metric-data",
				endpoint: "dashboard/datacenter/metric-data",
				service: "dashboard-data-center/get-metric-data"
			}
		}
	},
	dashboardHardwareAssets: {
		name: "dashboard-hardware-assets",
		operations: {
			renameFile: {
				name: "rename-file",
				endpoint: "devices/files/:fileId",
				service: "dashboard-hardware-assets/rename-file"
			},
			deleteFile: {
				name: "delete-file",
				endpoint: "devices/files/:fileId",
				service: "dashboard-hardware-assets/delete-file"
			},
			uploadFile: {
				name: "upload-file",
				endpoint: "devices/files",
				service: "dashboard-hardware-assets/upload-file"
			},
			downloadAsCsv: {
				name: "download-as-csv",
				endpoint: "devices/files/:fileId/export",
				service: "dashboard-hardware-assets/download-as-csv"
			},
			getUploadingStatus: {
				name: "get-uploading-status",
				endpoint: "devices/files/:fileId/status",
				service: "dashboard-hardware-assets/get-uploading-status"
			},
			downloadTemplate: {
				name: "download-template",
				endpoint: "devices/template",
				service: "dashboard-hardware-assets/download-template"
			},
			getFiles: {
				name: "get-files",
				endpoint: "devices/tenant/:tenantId/files",
				service: "dashboard-hardware-assets/get-files"
			},
			getCategories: {
				name: "get-categories",
				endpoint: "devices/categories",
				service: "dashboard-hardware-assets/get-categories"
			},
			getGeneralInformation: {
				name: "get-general-information",
				endpoint: "devices/files/:fileId/general-information",
				service: "dashboard-hardware-assets/get-general-information"
			},
			getTotalEmissionForPieChart: {
				name: "get-total-emission-for-pie-chart",
				endpoint: "devices/pie-chart/co2/:fileId",
				service: "dashboard-hardware-assets/get-total-emission-for-pie-chart"
			},
			getEmissionsByModel: {
				name: "get-emission-by-model",
				endpoint: "devices/bar-chart/models/:fileId",
				service: "dashboard-hardware-assets/get-emission-by-model"
			},
			getEmissionsByModelPerDevice: {
				name: "get-emission-by-model-per-device",
				endpoint: "devices/bar-chart/models/per-device/:fileId",
				service: "dashboard-hardware-assets/get-emission-by-model-per-device"
			},
			getEmissionsByRegion: {
				name: "get-emission-by-region",
				endpoint: "devices/bar-chart/co2/locations/:fileId",
				service: "dashboard-hardware-assets/get-emission-by-region"
			},
			getEmissionsByRegionPerDevice: {
				name: "get-emission-by-region-per-device",
				endpoint: "devices/bar-chart/co2/locations/per-device/:fileId",
				service: "dashboard-hardware-assets/get-emission-by-region-per-device"
			},
			getCo2ByInstallStatus: {
				name: "get-co2-by-install-status",
				endpoint: "devices/pie-chart/device-status/:fileId",
				service: "dashboard-hardware-assets/get-co2-by-install-status"
			},
			getEmissionsOverTime: {
				name: "get-emissions-over-time",
				endpoint: "devices/line-chart/co2/total-over-time/:fileId",
				service: "dashboard-hardware-assets/get-emissions-over-time"
			},
			getSavedLifecycleEmissions: {
				name: "get-saved-lifecycle-emissions",
				endpoint: "devices/line-chart/co2/lifecycle-saving/:fileId",
				service: "dashboard-hardware-assets/get-saved-lifecycle-emissions"
			},
			getEmissionsByCountryOverTime: {
				name: "get-emissions-location-over-time",
				endpoint: "devices/line-chart/co2/location-over-time/:fileId",
				service: "dashboard-hardware-assets/get-emissions-location-over-time"
			},
			getManufacturersEmission: {
				name: "get-manufacturers-emission",
				endpoint: "devices/manufacturers-emission/:fileId",
				service: "dashboard-hardware-assets/get-manufacturers-emission"
			},
			getCarbonFootprint: {
				name: "get-carbon-footprint",
				endpoint: "devices/bar-chart/co2/category/:fileId",
				service: "dashboard-hardware-assets/get-carbon-footprint"
			},
			getCarbonFootprintByScope: {
				name: "get-carbon-footprint-by-scope",
				endpoint: "devices/bar-chart/co2/scope/:fileId",
				service: "dashboard-hardware-assets/get-carbon-footprint-by-scope"
			},
			getManufacturers: {
				name: "get-manufacturers",
				endpoint: "devices/manufacturers/scope/:fileId",
				service: "dashboard-hardware-assets/get-manufacturers"
			},
			getAllCountries: {
				name: "get-countries",
				endpoint: "devices/countries",
				service: "dashboard-hardware-assets/get-countries"
			},
			getAllManufacturers: {
				name: "get-all-manufacturers",
				endpoint: "devices/manufacturers",
				service: "dashboard-hardware-assets/get-all-manufacturers"
			},
			compute: {
				name: "compute",
				endpoint: "devices/calculator/compute",
				service: "dashboard-hardware-assets/compute"
			},
			getGeneralCategories: {
				name: "get-general-categories",
				endpoint: "devices/general-categories",
				service: "dashboard-hardware-assets/get-general-categories"
			},
			getSpecificCategories: {
				name: "get-specific-categories",
				endpoint: "devices/general-categories/:category/specific-categories",
				service: "dashboard-hardware-assets/get-specific-categories"
			},
			getTotalEmission: {
				name: "get-total-emission",
				endpoint: "devices/calculator/bar-chart/co2/category/:calculationId",
				service: "dashboard-hardware-assets/get-total-emission"
			},
			getEmissionOverview: {
				name: "get-emission-overview",
				endpoint: "devices/calculator/table/overview/:calculationId",
				service: "dashboard-hardware-assets/get-emission-overview"
			},
			getCalculationKpis: {
				name: "get-calculation-kpis",
				endpoint: "devices/calculator/KPI/:calculationId",
				service: "dashboard-hardware-assets/get-calculation-kpis"
			},
			getEmissionByScope: {
				name: "get-emission-by-scope",
				endpoint: "devices/calculator/pie-chart/scope/:calculationId",
				service: "dashboard-hardware-assets/get-emission-by-scope"
			},
			getEmissionByManufacturer: {
				name: "get-emission-by-manufacturer",
				endpoint: "devices/calculator/pie-chart/mpn/:calculationId",
				service: "dashboard-hardware-assets/get-emission-by-manufacturer"
			},
			saveCalculation: {
				name: "save-calculation",
				endpoint: "devices/calculator/save/:calculationId",
				service: "dashboard-hardware-assets/save-calculation"
			},
			deleteCalculation: {
				name: "delete-calculation",
				endpoint: "devices/calculator/:calculationId",
				service: "dashboard-hardware-assets/delete-calculation"
			},
			getCalculationStatus: {
				name: "get-calculation-status",
				endpoint: "devices/calculator/:calculationId/status",
				service: "dashboard-hardware-assets/get-calculation-status"
			},
			getScenario: {
				name: "get-scenario",
				endpoint: "devices/whatif/scenario",
				service: "dashboard-hardware-assets/get-scenario"
			},
			getScenarioStatus: {
				name: "get-scenario-status",
				endpoint: "devices/whatif/scenarios/:scenarioId/status",
				service: "dashboard-hardware-assets/get-scenario-status"
			},
			deleteScenario: {
				name: "delete-scenario",
				endpoint: "devices/whatif/scenarios/:scenarioId",
				service: "dashboard-hardware-assets/delete-scenario"
			},
			getEmissionOverviewForBarChart: {
				name: "get-emission-overview-for-bar-chart",
				endpoint: "devices/whatif/bar-chart/co2/overview/:scenarioId",
				service: "dashboard-hardware-assets/get-emission-overview-for-bar-chart"
			},
			getTotalEmissionByCategory: {
				name: "get-total-emission-by-category",
				endpoint: "devices/whatif/bar-chart/co2/category/:scenarioId",
				service: "dashboard-hardware-assets/get-total-emission-by-category"
			},
			getTotalEmissionByManufacturer: {
				name: "get-total-emission-by-manufacturer",
				endpoint: "devices/whatif/bar-chart/co2/manufacturer/:scenarioId",
				service: "dashboard-hardware-assets/get-total-emission-by-manufacturer"
			}
		}
	},
	dashboardHardwareAssetsRealtime: {
		name: "dashboard-hardware-assets-realtime",
		operations: {
			getInformations: {
				name: "get-informations",
				endpoint: "devices/realtime/informations",
				service: "dashboard-hardware-assets-realtime/get-informations"
			},
			getTotalEmissions: {
				name: "get-total-emissions",
				endpoint: "devices/realtime/assets/total",
				service: "dashboard-hardware-assets-realtime/get-total-emissions"
			},
			getEmissionsByModelTotal: {
				name: "get-emissions-by-model-total",
				endpoint: "devices/realtime/bar-chart/co2/models/total",
				service: "dashboard-hardware-assets-realtime/get-emissions-by-model-total"
			},
			getEmissionsByLocation: {
				name: "get-emissions-by-location",
				endpoint: "devices/realtime/bar-chart/co2/by-location",
				service: "dashboard-hardware-assets-realtime/get-emissions-by-location"
			},
			getEmissionsByModelPerDevice: {
				name: "get-emissions-by-model-per-device",
				endpoint: "devices/realtime/bar-chart/co2/models/per-device",
				service: "dashboard-hardware-assets-realtime/get-emissions-by-model-per-device"
			},
			getManufacturersEmission: {
				name: "get-manufacturers-emission",
				endpoint: "devices/realtime/manufacturers-emission",
				service: "dashboard-hardware-assets-realtime/get-manufacturers-emission"
			},
			getManufacturerPieChart: {
				name: "get-manufacturer-pie-chart",
				endpoint: "devices/realtime/pie-chart/co2",
				service: "dashboard-hardware-assets-realtime/get-manufacturer-pie-chart"
			},
			getCarbonIntensityMap: {
				name: "get-carbon-intensity-map",
				endpoint: "devices/realtime/carbon-intensity",
				service: "dashboard-hardware-assets-realtime/get-carbon-intensity-map"
			},
			getEnergyConsumption: {
				name: "get-energy-consumption",
				endpoint: "devices/realtime/line-chart/energy-consumption",
				service: "dashboard-hardware-assets-realtime/get-energy-consumption"
			},
			getEmbodiedEmissions: {
				name: "get-embodied-emissions",
				endpoint: "devices/realtime/line-chart/embodied-emissions",
				service: "dashboard-hardware-assets-realtime/get-embodied-emissions"
			}
		}
	},
	dashboardDataCenters: {
		name: "dashboard-data-centers",
		operations: {
			getUserSiteList: {
				name: "get-user-site-list",
				endpoint: "dashboard/datacenter/sites",
				service: "dashboard-data-centers/get-user-site-list"
			},
			getMetricOverview: {
				name: "get-metric-overview",
				endpoint: "dashboard/datacenter/metric-overview",
				service: "dashboard-data-centers/get-metric-overview"
			},
			getUserSiteMetricData: {
				name: "get-user-site-metric-data",
				endpoint: "dashboard/datacenter/metric-data",
				service: "dashboard-data-centers/get-user-site-metric-data"
			}
		}
	},
	ai: {
		name: "dashboard-ai",
		operations: {
			getFiles: {
				name: "get-files",
				endpoint: "ai/tenant/:tenantId/files",
				service: "dashboard-ai/get-files"
			},
			getFileStatus: {
				name: "get-file-status",
				endpoint: "ai/tenant/:tenantId/files/:fileId/status",
				service: "dashboard-ai/get-file-status"
			},
			uploadFile: {
				name: "upload-file",
				endpoint: "ai/tenant/:tenantId/files",
				service: "dashboard-ai/upload-file"
			},
			getFileEmissions: {
				name: "get-file-emissions",
				endpoint: "ai/tenant/:tenantId/files/:fileId/emissions",
				service: "dashboard-ai/get-file-emissions"
			},
			getGeneralInformation: {
				name: "get-general-information",
				endpoint: "ai/tenant/:tenantId/files/:fileId/general-information",
				service: "dashboard-ai/get-general-information"
			},
			getCo2AppsPerformance: {
				name: "get-co2-apps-performance",
				endpoint: "ai/tenant/:tenantId/files/:fileId/line-chart/co2/apps-performance",
				service: "dashboard-ai/get-co2-apps-performance"
			},
			getWaterAppsPerformance: {
				name: "get-water-apps-performance",
				endpoint: "ai/tenant/:tenantId/files/:fileId/line-chart/water/apps-performance",
				service: "dashboard-ai/get-water-apps-performance"
			},
			getEnvironmentalImpactByCompany: {
				name: "get-environmental-impact-by-company",
				endpoint: "ai/tenant/:tenantId/files/:fileId/environmental-impact/by-company",
				service: "dashboard-ai/get-environmental-impact-by-company"
			},
			getEnvironmentalImpactByModel: {
				name: "get-environmental-impact-by-model",
				endpoint: "ai/tenant/:tenantId/files/:fileId/environmental-impact/by-model",
				service: "dashboard-ai/get-environmental-impact-by-model"
			},
			getWaterUsageByModel: {
				name: "get-water-usage-by-model",
				endpoint: "ai/files/:fileId/water-usage/by-model",
				service: "dashboard-ai/get-water-usage-by-model"
			},
			getBest10ModelsByEmission: {
				name: "get-best-10-models-by-emission",
				endpoint: "ai/files/:fileId/bar-chart/co2/best-10-models-per-token",
				service: "dashboard-ai/get-best-10-models-by-emission"
			},
			getBest10ModelsByWaterUsage: {
				name: "get-best-10-models-by-water-usage",
				endpoint: "ai/files/:fileId/bar-chart/water/best-10-models-per-token",
				service: "dashboard-ai/get-best-10-models-by-water-usage"
			},
			getModelEmissions: {
				name: "get-model-emissions",
				endpoint: "ai/tenant/:tenantId/files/:fileId/model-emissions",
				service: "dashboard-ai/get-model-emissions"
			},
			renameFile: {
				name: "rename-file",
				endpoint: "ai/tenant/:tenantId/files/:fileId",
				service: "dashboard-ai/rename-file"
			},
			deleteFile: {
				name: "delete-file",
				endpoint: "ai/tenant/:tenantId/files/:fileId",
				service: "dashboard-ai/delete-file"
			},
			exportFile: {
				name: "export-file",
				endpoint: "ai/files/:fileId/export",
				service: "dashboard-ai/export-file"
			},
			downloadTemplate: {
				name: "download-template",
				endpoint: "ai/template",
				service: "dashboard-ai/download-template"
			}
		}
	},
	strategicApplications: {
		name: "strategic-applications",
		operations: {
			getFiles: {
				name: "get-files",
				endpoint: "sta/tenant/:tenantId/files",
				service: "strategic-applications/get-files"
			},
			uploadFile: {
				name: "upload-file",
				endpoint: "sta/tenant/:tenantId/files",
				service: "strategic-applications/upload-file"
			},
			getFileStatus: {
				name: "get-file-status",
				endpoint: "sta/tenant/:tenantId/files/:fileId/status",
				service: "strategic-applications/get-file-status"
			},
			renameFile: {
				name: "rename-file",
				endpoint: "sta/tenant/:tenantId/files/:fileId",
				service: "strategic-applications/rename-file"
			},
			deleteFile: {
				name: "delete-file",
				endpoint: "sta/tenant/:tenantId/files/:fileId",
				service: "strategic-applications/delete-file"
			},
			exportFile: {
				name: "export-file",
				endpoint: "sta/tenant/:tenantId/files/:fileId/export",
				service: "strategic-applications/export-file"
			},
			downloadTemplate: {
				name: "download-template",
				endpoint: "sta/template",
				service: "strategic-applications/download-template"
			},
			getGeneralInformation: {
				name: "get-general-information",
				endpoint: "sta/tenant/:tenantId/file/:fileId/general-information",
				service: "strategic-applications/get-general-information"
			},
			getEmissionApplications: {
				name: "get-emission-applications",
				endpoint: "sta/tenant/:tenantId/file/:fileId/bar-chart/co2/applications",
				service: "strategic-applications/get-emission-applications"
			},
			getEmissionByScope: {
				name: "get-emission-by-scope",
				endpoint: "sta/tenant/:tenantId/file/:fileId/pie-chart/co2/scope",
				service: "strategic-applications/get-emission-by-scope"
			},
			getEmissionByDeployment: {
				name: "get-emission-by-deployment",
				endpoint: "sta/tenant/:tenantId/file/:fileId/pie-chart/co2/deployment",
				service: "strategic-applications/get-emission-by-deployment"
			},
			getTotalEmissionsOvertime: {
				name: "get-total-emissions-overtime",
				endpoint: "sta/tenant/:tenantId/files/:fileId/line-chart/co2/total-over-time",
				service: "strategic-applications/get-total-emissions-overtime"
			},
			getEnvironmentalImpactByApplication: {
				name: "get-environmental-impact-by-application",
				endpoint: "sta/file/:fileId/environmental-impact/by-application",
				service: "strategic-applications/get-environmental-impact-by-application"
			}
		}
	},
	regions: {
		name: "regions",
		operations: {
			getCarbonIntensityByRegion: {
				name: "get-carbon-intensity-by-region",
				endpoint: "dashboard/line-chart/ci/:region",
				service: "regions/get-carbon-intensity-by-region"
			},
			getAverageCarbonIntensity: {
				name: "get-average-carbon-intensity",
				endpoint: "dashboard/bar-chart/ci/regional",
				service: "regions/get-average-carbon-intensity"
			}
		}
	},
	whatIf: {
		name: "what-if",
		operations: {
			getUserWhatIfData: {
				name: "get-user-what-if-data",
				endpoint: "whatif/apps/:appId",
				service: "what-if/get-user-what-if-data"
			}
		}
	},
	whatIfScenario: {
		name: "what-if-scenario",
		operations: {
			createNewScenario: {
				name: "create-new-scenario",
				endpoint: "whatif/apps/:appId/scenarios",
				service: "what-if-scenario/create-new-scenario"
			},
			getScenarioInfo: {
				name: "get-scenario-info",
				endpoint: "whatif/apps/:appId/scenarios/:scenarioId",
				service: "what-if-scenario/get-scenario-info"
			},
			deleteScenario: {
				name: "delete-scenario",
				endpoint: "whatif/apps/:appId/scenarios/:scenarioId",
				service: "what-if-scenario/delete-scenario"
			},
			getScenarioSimulationStatus: {
				name: "get-scenario-simulation-status",
				endpoint: "whatif/apps/:appId/scenarios/:scenarioId/status",
				service: "what-if-scenario/get-scenario-simulation-status"
			}
		}
	},
	whatIfCarbonIntensity: {
		name: "what-if-carbon-intensity",
		operations: {
			getAllCarbonIntensity: {
				name: "get-all-carbon-intensity",
				endpoint: "whatif/carbonintensity",
				service: "what-if-carbon-intensity/get-all-carbon-intensity"
			},
			getMonthlyAverageByRegion: {
				name: "get-monthly-average-by-region",
				endpoint: "whatif/carbonintensity/:region",
				service: "what-if-carbon-intensity/get-monthly-average-by-region"
			},
			getHourlyAverageByRegion: {
				name: "get-hourly-average-by-region",
				endpoint: "whatif/carbonintensity/:region/average",
				service: "what-if-carbon-intensity/get-hourly-average-by-region"
			}
		}
	},
	whatIfLayer: {
		name: "what-if-layer",
		operations: {
			editAllScenarioLayers: {
				name: "edit-all-scenario-layers",
				endpoint: "whatif/apps/:appId/scenarios/:scenarioId/layers",
				service: "what-if-layer/edit-all-scenario-layers"
			},
			editScenarioLayer: {
				name: "edit-scenario-layer",
				endpoint: "whatif/apps/:appId/scenarios/:scenarioId/layers/:layerId",
				service: "what-if-layer/edit-scenario-layer"
			}
		}
	},
	whatIfSimulation: {
		name: "what-if-simulation",
		operations: {
			runSimulation: {
				name: "run-simulation",
				endpoint: "whatif/simulation/scenarios/:scenarioId",
				service: "what-if-simulation/run-simulation"
			}
		}
	},
	calculator: {
		name: "calculator",
		operations: {
			getCalculatorFormData: {
				name: "get-calculator-form-data",
				endpoint: "usersDashboard/calculator/form-data/cloud-provider",
				service: "calculator/get-calculator-form-data"
			},
			getOnPremiseOptions: {
				name: "get-on-premise-options",
				endpoint: "usersDashboard/calculator/form-data/on-premise/regions",
				service: "calculator/get-on-premise-options"
			},
			getCloudProviderOptions: {
				name: "get-cloud-provider-options",
				endpoint: "usersDashboard/calculator/form-data/cloud-provider/:id",
				service: "calculator/get-cloud-provider-options"
			},
			startCalculator: {
				name: "start-calculator",
				endpoint: "usersDashboard/calculator/:tenantId",
				service: "calculator/start-calculator"
			}
		}
	},
	cloud: {
		name: "cloud",
		operations: {
			getCloudFilters: {
				name: "get-cloud-filters",
				endpoint: "cloud/filters",
				service: "cloud/get-cloud-filters"
			},
			getCloudPerformance: {
				name: "get-cloud-performance",
				endpoint: "cloud/line-chart/co2/cloud-performance",
				service: "cloud/get-cloud-performance"
			},
			getTotalEmissionForPieChart: {
				name: "get-cloud-emission-for-pie-chart",
				endpoint: "cloud/pie-chart/co2/cloud-emissions",
				service: "cloud/get-cloud-emission-for-pie-chart"
			},
			getTotalCo2: {
				name: "get-total-co2",
				endpoint: "cloud/kpi/co2",
				service: "cloud/get-total-co2"
			},
			getWorst10Applications: {
				name: "get-worst-10-applications",
				endpoint: "cloud/bar-chart/co2/worst-10-applications",
				service: "cloud/get-worst-10-applications"
			},
			getWorst10Locations: {
				name: "get-worst-10-locations",
				endpoint: "cloud/bar-chart/co2/worst-10-locations",
				service: "cloud/get-worst-10-locations"
			},
			getEmissionsAnalysis: {
				name: "get-emissions-analysis",
				endpoint: "cloud/bar-chart/co2/emissions-analysis",
				service: "cloud/get-emissions-analysis"
			},
			getRegionsEmissions: {
				name: "get-regions-emissions",
				endpoint: "cloud/bar-chart/co2/regions-emissions",
				service: "cloud/get-regions-emissions"
			},
			exportCsv: {
				name: "export-csv",
				endpoint: "cloud/export",
				service: "cloud/export-csv"
			},
			exportReport: {
				name: "export-report",
				endpoint: "cloud/reportAutomation/get-report/:format",
				service: "cloud/export-report"
			}
		}
	}
};
